import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    backgroundColor: 'secondary.main',
    margin: '16px 24px',
    padding: '24px 32px',
  },
  title: {
    fontWeight: '600',
    fontSize: 22,
    color: 'common.grey850',
    mb: '16px',
  },
  crumbContainer: {
    mb: '16px',
  },
  fieldContainer: {
    mb: '8px',
  },
  buttonContainer: {
    marginTop: '24px',
    justifyContent: 'flex-end',
  },
  mappingError: {
    mb: '8px',
  },
  emailsField: {
    px: '8px',
  },
  emailChips: {
    alignContent: 'flex-start',
    border: '1px solid',
    borderColor: 'common.border',
    borderRadius: '4px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    minHeight: '56px',
    p: '8px',
  },
  emailChip: {
    maxWidth: '100%',
  },
  emailError: {
    mx: '14px',
  },
  requiredLabel: {
    color: 'common.error',
    ml: '3px',
  },
  noUnderline: {
    textDecoration: 'none',
    fontSize: 14,
  },
  prevLink: {
    color: 'grey.500',
  },
  list: {
    ml: '20px',
    display: 'block',
    textAlign: 'justify',
    marginTop: '16px',
    maxHeight: '200px',
    overflowY: 'auto',
  },
  listItems: {
    fontSize: 13,
    fontWeight: '400',
  },
  successMessage: {
    textAlign: 'center',
    fontWeight: '500',
    fontSize: 14,
    color: 'common.grey800',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
